import { useApi } from '@api/ApiProvider'
import { isUnauthorized, useStaffSession } from '@features/panel/StaffSession'
import { useMutation, useQueryClient } from '@tanstack/react-query'

// Claves de caché de los lugares mágicos: el mapa público y todo lo del personal (bajo 'panel',
// que se olvida al cerrar sesión).
export const MAGIC_PLACES_KEY = ['magic-places'] as const
export const STAFF_MAGIC_KEY = ['panel', 'magic'] as const

// Aprobar, retirar y eliminar un lugar mágico (spec `magic-place-proposals`), con la sesión del
// personal. Al terminar se refrescan el mapa y el listado; un 401 cierra la sesión.
export const useMagicPlaceModeration = () => {
	const api = useApi()
	const queryClient = useQueryClient()
	const { session, signOut } = useStaffSession()
	const token = session?.token ?? ''
	const refresh = async () => {
		await queryClient.invalidateQueries({ queryKey: MAGIC_PLACES_KEY })
		await queryClient.invalidateQueries({ queryKey: STAFF_MAGIC_KEY })
	}
	const onError = (error: unknown) => {
		if (isUnauthorized(error)) signOut()
	}
	return {
		approve: useMutation({
			mutationFn: (id: string) => api.approveMagicPlace(token, id),
			onSuccess: refresh,
			onError,
		}),
		retire: useMutation({
			mutationFn: (id: string) => api.retireMagicPlace(token, id),
			onSuccess: refresh,
			onError,
		}),
		remove: useMutation({
			mutationFn: (id: string) => api.deleteMagicPlace(token, id),
			onSuccess: refresh,
			onError,
		}),
	}
}
